import { render, staticRenderFns } from "./StatelessTags.vue?vue&type=template&id=1b64cb9c&scoped=true"
import script from "./StatelessTags.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatelessTags.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StatelessTags.vue?vue&type=style&index=0&id=1b64cb9c&prod&lang=scss"
import style1 from "./StatelessTags.vue?vue&type=style&index=1&id=1b64cb9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b64cb9c",
  null
  
)

export default component.exports